import { loginReducers } from "./login";
import { combineReducers } from "redux";

export const allReducers = combineReducers({
  loginReducers,
});
